var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form-row',{staticClass:"my-6",attrs:{"title":"List Price","no_border":true}},[_c('div',{staticClass:"sm:w-40"},[_c('input-money',{attrs:{"name":"list_price","value":_vm.listing_detail.list_price,"read_only":_vm.read_only}})],1)]),_vm._v(" "),_c('div',{staticClass:"border-b border-gray-400 sm:ml-46 mb-6"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }